

import { copyToClipboard as cp, date } from 'quasar'
// import date from '@node/quasar/src/utils/date.js'
// import cp from '@node/quasar/src/utils/copy-to-clipboard.js'


import { pp, notify, roles_list } from '@helpers'

export {
    dater,
    dateNow,
    secondsToTime,
    formatDate,
    reverseDate,
    getRandomRef,
    capitalizeFirstWords,
    rolesToString,
    copyToClipboard,
    capitalize,
    replaceComma,
    stripTags,
    strLimit,
    highlighter,
    nl2br,
    br2nl,
    pluralize,
    getSizeFile,
}



const dater = date
// const dater = proto.$q?.date
// const dater = {}


const dateNow = (format)=>{

    return formatDate({format: format})
}

const secondsToTime = (duration_in_seconds, long_format = false)=>{

    if(!duration_in_seconds){return ''}

    // Hours, minutes and seconds
    // ~~ is a shorthand for Math.floor
    var hrs = ~~(duration_in_seconds / 3600);
    var mins = ~~((duration_in_seconds % 3600) / 60);
    var secs = ~~duration_in_seconds % 60;

    var ret = "";

    if (hrs > 0) {
        ret += hrs + " "+(!long_format?"h ":pluralize(hrs, 'heure',false));
    }
    if (mins > 0) {
        ret += (long_format?'':(mins < 10 ? " 0" : " "))+ mins + " "+(!long_format?"m ":pluralize(mins, 'minute',false));
    }

    if (secs > 0) {
        ret += (long_format?(mins > 0?' et ':''): (secs < 10 ? " 0" : " "))+ secs + " "+(!long_format?"s":pluralize(secs, 'seconde',false));
    }
    return ret;
}

/**
 * Construct Date with or without hour
 *
 * @param DATE datetime (format :  Y-m-d H:i:s   (or with moment : YYYY-MM-DD HH:mm:ss)     e.g. 2000-01-02 12:00:00)
 * @param BOOL withHour
 * @param STRING format
 * @param BOOL full
 * @param BOOL justHour
 * @param BOOL withoutYear
 * @param OBJECT add
 * @param OBJECT sub
 * @returns String
*/
const formatDate = ({datetime, /* timestamp,  */format, full, withHour, justHour, withoutYear, add, sub})=>{

    var formatText = ''
    if( ! format){
        formatText = "DD[/]MM"+ (!withoutYear ? "[/]YYYY" : '') // default format: DD/MM/YYYY
    // }

    // var formatText = "DD/MM"+ (!withoutYear ? "/YY" : '')

    // if( ! withHour && format){
    //     formatText = "dddd D MMM"+ (!withoutYear ? " YYYY" : '')
    // }
    // if(withHour && format){
    //     formatText = "dddd D MMM" + (!withoutYear ? " YYYY" : '')+" à HH:mm"
    // }
    // if( ! format){

        if(justHour){
            formatText = "HH[h]mm"
        }
        else if(full){
            formatText = "dddd DD MMMM" + (!withoutYear ? " YYYY" : '')
        }

        if(withHour && ! justHour){
            formatText += " [à] HH[h]mm"
        }

    } else {
        formatText = format
    }


    if(_.isInteger(datetime)){ datetime = dater.formatDate(datetime, format) } // length: 13 numbers !



    if( ! datetime/*  && ! timestamp */){ datetime = Date.now() }

    var dateString = datetime

    if(add){
        // dateString = fn.dater.addToDate(datetime,
        dateString = dater.addToDate(datetime,
            {   days: add.days||0, months: add.months||0, years: add.years||0, hours: add.hours||0, minutes: add.minutes||0 })
    }
    else if(sub){
        dateString = dater.subtractFromDate(datetime,
            {   days: sub.days||0, months: sub.months||0, years: sub.years||0, hours: sub.hours||0, minutes: sub.minutes||0 })
    }

    dateString = dater.formatDate(dateString, formatText)

// log('in formatdate() - datetime: ', datetime, 'format: ', formatText, 'dateString: ', dateString)

    // if (date.isValid(dateString) || full) {
        // return _.includes(formatText,'MMM') ? _.startCase(dateString) : dateString // enlève les accents!
        return _.capitalize(dateString);
        // return _.startCase(dateString); // Majuscule à la première lettre de chaque mot, même au "à"
    // } else {
    //     return '???'
    // }
}

/**
 * Inverse l'ordre d'une date
 * @param {String} date_
 * @param {String} separator    default: /
 * @param {String} replace      default: -
 * @returns (par défaut) DD/MM/YYYY to YYYY-MM-DD
 */
const reverseDate = (date_ , separator = '/', replace = '-')=>{
    // if(_.includes(date_, '/')){
    //     return date_.split('/').reverse().join('-') // DD/MM/YYYY to YYYY-MM-DD
    // } else if(_.includes(date_, '-')){
    //     return date_.split('-').reverse().join('/') // YYYY-MM-DD to DD/MM/YYYY
    // }
    if( ! date_){
        date_ = formatDate({});//=> format DD/MM/YYYY
    }

    return date_.split(separator).reverse().join(replace) // default ex: DD/MM/YYYY to YYYY-MM-DD
}


const getRandomRef = (length = 8)=>{
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    let result = '';
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}




const capitalizeFirstWords = (str)=>{
    if(str){
        return _.upperFirst(str.toLowerCase())

        // var splitStr = str.toLowerCase().split(' ');
        // for (var i = 0; i < splitStr.length; i++) {
        //     // You do not need to check if i is larger than splitStr length, as your for does that for you
        //     // Assign it back to the array
        //     splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        // }
        // // Directly return the joined string
        // return splitStr.join(' ');
    }
    return ''
}


/**
 * Transform a role id to string role (used in Enfant/List.vue)
 * @param {Array} roles ex: ['admin','master']
 */
const rolesToString = (roles, mapper='name', pronom = false, plural = false)=>{

    // if(_.isEmpty(roles) || !_.size(proto.$page.props?.roles_list || [])){return '?'}
    if(_.isEmpty(roles)){return '?'}

    var str = '';

    // _.each(roles, r=>{
    //     if(_.isObject(r)){
    //         r = _.map(r, 'name').join('|')
    //     }
    //     str += r+'|'
    // })

    // // str += _.map(proto.pp.roles, r=>{

    //     if(_.isArray(roles)){
    //         if(_.isObject(roles[0])){
    //             roles = _.map(roles, mapper/* 'name' */)
    //         }
    //         roles = roles.join('|')

    // //         // roles = _.map(roles, 'name').join('|')
    //     }

    // //     return r
    // // })

//         // regex = new Regex(proto.pp.roles_list.map('name'))
// log(fn.roles_list(), roles)
    // str = _.replace(roles, /master|admin|supervisor|leader|supervised|gerant|1|2|3|4|5|6|7/g,
    // // str = _.replace(roles, `/${_.map(proto.pp.roles_list, 'name')}/g`,
    //         (e)=>{
    //                         log(e)
    //             return (pronom ? 'un ' : '') + _.find(fn.roles_list(), {[mapper]: e})?.fullname + (plural ? 's' : '')
    //             // return (pronom ? 'un ' : '') + _.find(proto.$page.props.roles_list, {name: e}).fullname + (plural ? 's' : '')
    //         })

    // str = _.replace(roles, /1|2|3|4|5|6|7/g,
    // // str = _.replace(roles, `/${_.map(proto.pp.roles_list, 'name')}/g`,
    //         (e)=>{
    //             log(e)
    //             return (pronom ? 'un ' : '') + _.find(fn.roles_list(),{[mapper]: Number(e)}).fullname + (plural ? 's' : '')
    //             // return (pronom ? 'un ' : '') + _.find(proto.$page.props.roles_list, {[mapper]: e}).fullname + (plural ? 's' : '')
    //         })


    // var str = '';

    // if( ! _.isArray(roles)){
    //     roles = [roles]
    // }

    // // var obj_ref = {master:'WebMaster',admin:'Administrateur',comptable:'Comptable',driver:'Chauffeur',guest:'Invité'}

    // str = _.replace(roles.join('|'), /master|admin|comptable|driver|guest/g,
    //         (e)=>{
    //             return (pronom ? 'un ' : '') +obj_ref[e] + (plural ? 's' : '')
    //         })

    _.each(roles, r=>{
        // log(r)
        str += (pronom ? 'un ' : '') + _.find(roles_list(), {[mapper]: (mapper != 'id' ? r?.[mapper] : r)})?.fullname + (plural ? 's' : '')+'|'
    })

    // log(str)

    return _.trim(str,'|').split('|').join(', ')
}


/**
 * Copy String to the clipboard
 * @param {String} str
 */
const copyToClipboard = (str, name = '')=>{

    //? fonctionne aussi:
    // const el = document.createElement('textarea');
    // el.value = str;
    // el.setAttribute('readonly', '');
    // el.style.position = 'absolute'; // for hidden textarea
    // el.style.left = '-9999px';		// for hidden textarea
    // document.body.appendChild(el);
    // el.select();
    // document.execCommand('copy');
    // document.body.removeChild(el);

    // quasar
    cp(str)
        .then(() => { notify('info', 'Contenu <b>'+name+'</b> copié.','',1500) })
        .catch(() => { notify('warning', 'Ooops... Impossible de copier <b>'+name+'</b>.','',1500) })
}


// capitalize plusieurs mots espacés
const capitalize = (str) => {
    if (!str) return '';

    var r = [],
        words = str.split(' ');
    _.forEach(words, (word)=>{
        r.push(_.upperFirst(word));
    });
    return r.join(' ');
}


/**
 * Remplace une virgule par un point
 *
 * Utilisation : fn.replaceComma('value', parent)  OR  value = fn.replaceComma(value)
 *
 * @param {Str|Num} value
 * @param {Object} parent
 */
const replaceComma = (value, parent)=>{
    if( ! value){return null}

    if(parent){
        let val = parent[value]

        parent[value] = _.includes(val, ',') ? val.replace(',', '.') : val
    }
    else {
        return _.includes(value, ',') ? value.replace(',', '.')/* .replace(/,/g, '.') */ : value
    }
}


/**
 * Replace tags html to space
 * @param {String} html
 * @returns {String}
 */
const stripTags = (html)=>{
    if(_.size(html)){
        html = html.replaceAll('<p>','\\n').replaceAll('<br>','\\n').replaceAll('<br/>','\\n').replaceAll('<br />','\\n')

        return html.replace(new RegExp("<.[^<>]*>|&nbsp;", "gi" ), ' ')
    }
    return html
}


/**
 * Text limiter
 * @param {String} str
 * @param {Integer} limit
 */
const strLimit = (str, limit = 100, end = '...')=>{

    if(str && str.length > limit){
//		return _.truncate(str, { length: limit, separator: end });
        return _.truncate(str, { length: limit, omission: end });

//		str = this.stripTags(str);
//		return str.substr(0, limit) + end;
    }
//	else {
        return str ? str : '';
//	}
}

const highlighter = (text, filter)=>{
    //   var inputText = document.getElementById("inputText");
    //   var innerHTML = inputText.innerHTML;
    //   var index = innerHTML.indexOf(text);
    //   if (index >= 0) {
    //    innerHTML = innerHTML.substring(0,index) + "<span class='highlight'>" + innerHTML.substring(index,index+text.length) + "</span>" + innerHTML.substring(index + text.length);
    //    inputText.innerHTML = innerHTML;
    //   }
// log(text, filter)
    if(text && filter){
        var regex = new RegExp(filter, 'gi')

        return text.replace(regex,`<span class='highlight'>${filter.toUpperCase()}</span>`)
    }
    return text;
}


/**
 * Retours au chariot js remplacés par des <br/>
 * @param {String} str
 * @returns {String}
 */
const nl2br = (str, breakTag = '<br/>', needle)=>{
    // var breakTag = '<br/>'; // sames with php nl2br() function
//	return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
    return !needle ? (str?.replaceAll(/(?:\r\n|\n\r|\r|\n|\\r\\n|\\n\\r|\\r|\\n)/g, breakTag) || str) : str?.replaceAll(needle, breakTag) || str;
}

/**
 * <br> <br/>  <br /> remplacés par des retours au chariot js
 * for update texte with  <br>  in input type=textarea (Fiche de transmission)
 * @param {String} str
 * @returns {String}
 */
const br2nl = (str)=>{
    var breakTag = "\n"
    return str.replace(/<br\s*[\/]?>\s?/gi, breakTag)
}

const pluralize = (number, text = '', show_number_before_text = true, replace = 's')=>{

    var arr = text?.split(' '), // <-- text can to have multiple words !!
    t = ''

    if(Number(number) > 1 && _.isArray(arr)){
        arr.forEach((e)=>{
            // t += e + replace +' '
            t += e + ( ! _.includes(['/','-',' ','|','&'], e) ? replace : '') + ' '
        });
        return (show_number_before_text ? number+' ' : '') + t
    } else {
        return (show_number_before_text ? number+' ' : '') + text
    }
}


const getSizeFile = (size_in_octet)=>{


    var aSize = Math.abs(parseInt(size_in_octet, 10))

    var def = [[1, 'octets'], [1024, 'Ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']]

    for(var i=0; i<def.length; i++){
        if(aSize<def[i][0]){
            return (aSize/def[i-1][0]).toFixed(2)+' '+def[i-1][1]
        }
    }

}



// export default {




    // formatNumber: (n)=>{
    //     return Number(n).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    // },

    // formatAmount: (amount, sup = true, symbol = '€', fixedTo = 2) => {

    //     if(!amount){ return '0,00€'}

    //     // amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')// integer
    //     var num_str = Number(amount).toFixed(fixedTo).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') // float

    //     var n = num_str.split('.')

    //     return sup && (amount >= 1 || amount <= -1)   ? `${n[0]}&nbsp;${symbol}&nbsp;<sup>${n[1]}</sup>` // 12 345 € 67
    //                                 : `${n[0]},${n[1]} ${symbol}`                      // 0,89 €
    // },
/*
    formatAmount_OLD: (amount) => {
        var n = ['0', '00'];


        if(amount && amount !== 0){

            if(_.isNaN(Number(amount))){ // ex: "5,50"
                n = amount.split(',')
            } else {
                n = Number(amount).toFixed(2).split('.')
            }

            if(n[0] === '0'){
                return '0,'+n[1]+'&nbsp;€'
            }
        }

// log('in formatAmount()',amount)

        if(Number(n[0]) > 999){
            n[0].toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')

            // var ff = '' // french format
            // var n0_reverse = n[0].reverse()
            // var gap_size = 3;
            // while (n0_reverse.length > 0) // Loop through string
            // {
            //     ff = ff + " " + n0_reverse.substring(0,gap_size) // Insert space character
            //     n0_reverse = n0_reverse.substring(gap_size)  // Trim String
            // }
            // n[0] = ff;
        }

        return n[0] +'&nbsp;€&nbsp;<sup>'+ n[1] +'</sup>'

    },
*/



    /**
     * Date to Object{year,month:day}
     * @param {String} date_  format DD/MM/YYYY | DD-MM-YYYY
     * @returns {Object}
     */
    // splitDateForCarbon(date_){
    //     if( ! date_){
    //         date_ = fn.dateNow('DD-MM-YYYY')
    //     }
    //     var split = date_.split( _.includes(date_, '/') ? '/' : '-' )

    //     return {year: Number(split[2]), month: Number(split[1]), day: Number(split[0])}
    // },



    // duplicate function of Vue Prototype pluralize (in config.js)
    // pluralize: function (number, text, show_number_before_text = true, replace = 's'){

    //     var arr = text.split(' '), // <-- text can to have multiple word !!
    //         t = '';
    //     if(Number(number) > 1){
    //         arr.forEach(function(e){
    //             t += e + replace +' ';
    //         });
    //         return (show_number_before_text ? number+' ' : '') + t;
    //     } else {
    //         return (show_number_before_text ? number+' ' : '') + text;
    //     }
    // },


    // fullname: function (u){
    //     if(u){
    //         if(u.nom && u.prenom){
    //             return _.upperCase(u.nom)+' '+_.capitalize(u.prenom);
    //         }
    //         if(u.name){
    //             return _.capitalize(u.name);
    //         }
    //     }
    //     return '???';

    // },

    // feminar: function (str){

    // 	if(user && user.gender){

    // 		if(user.gender != 'Mr'){
    // 			return str+'e';
    // 		}
    // 	}
    // 	return str;
    // },


    // REPLACED BY _.deburr()
    //strSlugify: function (text)
    //{
    //	if(text == undefined || text == ''){return;}
    //
    //	text = text.toString().toLowerCase();
    //
    //	// remove accents, swap ñ for n, etc
    //    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    //    var to   = "aaaaeeeeiiiioooouuuunc------";
    //    for (var i=0, l=from.length ; i<l ; i++) {
    //        text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    //	}
    //	return text
    //		.replace(/\s+/g, '-')           // Replace spaces with -
    //		.replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    //		.replace(/\-\-+/g, '-')         // Replace multiple - with single -
    //		.replace(/^-+/, '')             // Trim - from start of text
    //		.replace(/-+$/, '');            // Trim - from end of text
    //},



    /**
     * Supprime les Retours au chariot js
     * @param {String} str
     * @returns {String}
     */
    // del_nl = function (str) {
    // 	return str.replace(/(\r\n|\n\r|\r|\n)/g, '');
    // },
    /**
     * Supprime les <br>
     * @param {String} str
     * @returns {String}
     */
    // del_br = function (str) {
    // 	return str.replace(/<br\s*[\/]?>\s?/gi, '');
    // },


// }
